/*

Controls to add new media sources

*/
import useCapture from "../../../hooks/MediaInput/BrowserMediaDevices";
import Menu from "./Menu";
import "../style.css";
// Controls to add new inputs
// Can also initialize a new empty editor/stream process/canvas
const AddSource = (props) => {
  const addSource = (newObj) => {
    props.addMediaStream(newObj);
  };
  const [addCamera, addScreenShare] = useCapture({ callback: addSource });

  return (
    <Menu
      menuTitle="New Source"
      subMenus={[
        <div
          className="flex-item button"
          style={{ marginLeft: "1em", marginRight: "1em" }}
          onClick={() => {
            addCamera();
          }}
          key="btn-add-cam"
        >
          Camera
        </div>,
        <div
          className="flex-item button"
          style={{ marginLeft: "1em", marginRight: "1em" }}
          onClick={() => {
            addScreenShare();
          }}
          key="btn-add-screen"
        >
          ScreenShare
        </div>,
      ]}
    />
  );
};

export default AddSource;
